import React from "react";
import { Link } from "react-router-dom";
import { Plus } from "lucide-react";
import { useDispatch } from "react-redux";
import {
  clearState,
  setCreateNewMeetingPage,
} from "../../redux/actions/meetingActions/MeetingAction";

const AddButton = React.memo(() => {
  const dispatch = useDispatch();
  const handleClick = (event) => {
    if (event.ctrlKey) {
      event.preventDefault(); // Prevents opening in new tab
      event.stopPropagation(); // Prevents bubbling up if needed
      return;
    }

    dispatch(clearState(true));

    dispatch(
      setCreateNewMeetingPage({
        status: true,
        isClearingleMeetingDetails: false,
      })
    );
  };
  return (
    <Link
      to="/create-meeting"
      state={{ isNewMeeting: true }}
      style={{ textDecoration: "none" }}
    >
      <button className="plus-icon" onClick={handleClick}>
        <Plus size={32} />
      </button>
    </Link>
  );
});

export default AddButton;
